"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferKeyToFriendly = void 0;
const transferKeyToFriendly = (key) => {
    switch (key) {
        case "airport_golf":
            return "Airport & Golf transfers";
        case "airport":
            return "Airport transfers only";
        case "golf":
            return "Golf transfers only";
        case "none_required":
            return "None required";
        default:
            return "";
    }
};
exports.transferKeyToFriendly = transferKeyToFriendly;
